module.exports = __webpack_public_path__ + "static/state-of-the-u@2x-30ca3fa8777ee41aecc0dbcaa023807f.png";